export const DEFAULT_FILTERS = { q: '', cat: 'all', country: 'all', price: [0, 2000000], diaspora: false, sort: 'recent' };
export const MAX_PRICE = 2000000;

export const filtersToParams = (f) => ({
  q: f.q || undefined,
  cat: f.cat !== 'all' ? f.cat : undefined,
  country: f.country !== 'all' ? f.country : undefined,
  diaspora: f.diaspora || undefined,
  min_price: f.price[0] > 0 ? f.price[0] : undefined,
  max_price: f.price[1] < MAX_PRICE ? f.price[1] : undefined,
  sort: f.sort,
  limit: 60,
});
